import { ToastAlertTypes } from '@genial/components';

export const screenName = 'boleta-rapida';
export const defaultErrorMessage: [ToastAlertTypes.Type, string, string] = [
  'error',
  'Erro.',
  'Ocorreu um erro ao enviar ordem,\nverifique sua conexão com a internet e\ntente novamente em instantes.',
];

export const messageError = '--';

export const productServiceTypes = {
  FixedIncome: 'FixedIncome',
  Equity: 'Equities',
  Fund: 'Fund',
  DirectTreasury: 'Treasury',
  StructuredOperations: 'COES',
} as const;

export const paramsRequestType = {
  Fund: 'fundOrderCreateRequest',
  FixedIncome: 'fixedIncomeOrderCreateRequest',
  Equity: 'equityOrderCreateRequest',
  DirectTreasury: 'treasuryOrderCreateRequest',
  StructuredOperations: 'coeOrderBuyRequest',
} as const;
